import { styled } from 'styled-components';
import { device, theme, Utils } from 'team-hero-ui';

const { pxToRem, flexFn } = Utils;

export const JobAdApplyFormStyled = styled.div`
  width: 100%;
  height: 100dvh;
  ${flexFn('center', 'start')}
`;

export const ErrorWrapper = styled.div`
  width: 100%;
  height: 100dvh;
`;

export const WrapperContainerStyled = styled.div`
  width: ${pxToRem(600)};
  max-width: 100vw;
  min-width: ${pxToRem(320)};
  margin-top: ${pxToRem(40)};
  margin-bottom: ${pxToRem(40)};
`;

export const StepWrapperStyled = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.primary.white};
  border-radius: ${pxToRem(4)};
`;

export const BackButtonWrapperStyled = styled.div`
  width: 100%;
  ${flexFn('flex-start')};
  padding: ${pxToRem([20, 10])};

  @media ${device.sm} {
    padding: ${pxToRem(20)};
  }
`;

interface IItemStyled {
  $height: number;
}

export const ItemStyled = styled.div<IItemStyled>`
  height: ${({ $height }) => pxToRem($height)};
`;
